import api from './api';

export interface PasswordListItem {
  idPassword: string;
  tieneClave: boolean;
}

export interface PasswordPagedResult {
  items: PasswordListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface PasswordSearchParams {
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

const passwordService = {
  getPaged: async (params: PasswordSearchParams): Promise<PasswordPagedResult> => {
    const resp = await api.get<PasswordPagedResult>('/api/Passwords', { params });
    return resp.data;
  },

  /** Lista compacta para selects (IdPassword). */
  listIds: async (): Promise<PasswordListItem[]> => {
    const data = await passwordService.getPaged({ pageNumber: 1, pageSize: 100 });
    return data.items;
  },

  create: async (idPassword: string, clave: string): Promise<PasswordListItem> => {
    const resp = await api.post<PasswordListItem>('/api/Passwords', { idPassword, clave });
    return resp.data;
  },

  update: async (idPassword: string, clave: string): Promise<void> => {
    await api.put(`/api/Passwords/${encodeURIComponent(idPassword)}`, { clave });
  },

  remove: async (idPassword: string): Promise<void> => {
    await api.delete(`/api/Passwords/${encodeURIComponent(idPassword)}`);
  },
};

export default passwordService;
